import React, { useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';

const LandingPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const link = document.createElement('link');
    link.href = 'https://fonts.googleapis.com/css2?family=Varela+Round&display=swap';
    link.rel = 'stylesheet';
    document.head.appendChild(link);

    document.documentElement.style.overflow = 'auto';
    document.body.style.overflow = 'auto';
    document.body.style.height = 'auto';
    return () => {
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      document.body.style.height = '100%';
    };
  }, []);

  const goToApp = () => navigate('/app');

  return (
    <div style={{ fontFamily: "'Varela Round', sans-serif", direction: 'rtl', backgroundColor: '#fff', minHeight: '100vh', color: '#2d3436' }}>

      <header style={{ backgroundColor: '#eff6ff', padding: '60px 20px', display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
        <div style={{ width: '90px', height: '90px', borderRadius: '24px', backgroundColor: '#2563eb', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '20px', transform: 'rotate(-6deg)', boxShadow: '0 8px 20px rgba(37,99,235,0.3)' }}>
          <span style={{ fontSize: '44px' }}>🚚</span>
        </div>
        <h1 style={{ fontSize: '2.8rem', marginBottom: '10px', color: '#2563eb', fontWeight: 'bold' }}>דרייבר.ישראל</h1>
        <p style={{ fontSize: '1.2rem', marginBottom: '25px', color: '#444', maxWidth: '600px' }}>
          משלוחים מהירים בקהילה. <br />
          <strong>שלח חבילה או הרווח כשליח — מהר, פשוט והוגן.</strong>
        </p>
        <button onClick={goToApp} style={{ backgroundColor: '#2563eb', color: 'white', padding: '16px 40px', fontSize: '1.1rem', border: 'none', borderRadius: '50px', cursor: 'pointer', fontWeight: 'bold', boxShadow: '0 4px 15px rgba(37,99,235,0.3)' }}>
          כניסה לאפליקציה ➜
        </button>
      </header>

      <main style={{ maxWidth: '800px', margin: '0 auto', padding: '40px 20px' }}>
        <section style={{ textAlign: 'center', marginBottom: '40px' }}>
          <h2 style={{ fontSize: '1.8rem', marginBottom: '15px' }}>איך זה עובד?</h2>
          <p style={{ fontSize: '1.1rem', color: '#636e72' }}>
            דרייבר.ישראל מחבר בין אנשים שצריכים לשלוח חבילה לבין שליחים מהאזור הקרוב.
            השולח מפרסם משלוח, רואה מחיר משוער מיידי, ושליח זמין לוקח אותו — והכל במעקב חי על המפה.
          </p>
        </section>

        <section style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '20px' }}>
          <div style={cardStyle}><h3>📦 שליחת חבילות</h3><p>מסמכים, קניות, תרופות או כל חבילה — מנקודה לנקודה במהירות.</p></div>
          <div style={cardStyle}><h3>🚗 הרווחה כשליח</h3><p>הצטרף כשליח, עבור למצב מקוון, וקבל משלוחים באזורך בזמן הפנוי שלך.</p></div>
          <div style={cardStyle}><h3>📍 מעקב חי</h3><p>השולח עוקב אחרי השליח על המפה בזמן אמת, מרגע האיסוף ועד המסירה.</p></div>
        </section>
      </main>

      <footer style={{ padding: '30px', textAlign: 'center', backgroundColor: '#f9f9f9', marginTop: '40px' }}>
        <p>© 2026 דרייבר.ישראל - משלוחים בקהילה.</p>
        <div style={{ marginTop: '10px', fontSize: '0.9rem' }}>
          <Link to="/privacy" style={{ color: '#2563eb', textDecoration: 'none', marginLeft: '15px' }}>מדיניות פרטיות</Link>
          <span style={{ color: '#ccc' }}>|</span>
          <Link to="/terms" style={{ color: '#2563eb', textDecoration: 'none', marginRight: '15px' }}>תנאי שימוש</Link>
        </div>
        <p style={{ fontSize: '0.8rem', color: '#999', marginTop: '10px' }}>
          This site is protected by reCAPTCHA and the Google
          <a href="https://policies.google.com/privacy" style={{ color: '#999' }}> Privacy Policy</a> and
          <a href="https://policies.google.com/terms" style={{ color: '#999' }}> Terms of Service</a> apply.
        </p>
      </footer>
    </div>
  );
};

const cardStyle = { background: '#fff', padding: '20px', borderRadius: '20px', border: '1px solid #f0f0f0', boxShadow: '0 4px 10px rgba(0,0,0,0.02)', textAlign: 'center' };

export default LandingPage;
